import consumer from "./consumer"
import * as Turbo from "@hotwired/turbo"

consumer.subscriptions.create("SchedulingChannel", {
  connected() {
    console.log("Conectado al SchedulingChannel para actualizaciones en tiempo real.");
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // Cuando recibimos datos con una clave 'turbo_stream',
    // se los pasamos a Turbo para que los procese.
    if (data && data.turbo_stream) {
      console.log("SchedulingChannel: Recibido Turbo Stream. Actualizando vista.");
      Turbo.renderStreamMessage(data.turbo_stream);
    }
  }
});
